import React, { useState, useEffect } from 'react';
import { ChakraProvider, VStack, Button } from '@chakra-ui/react';
import DoctorListPage from './DoctorListPage';
import DoctorTimeTablePage from './DoctorTimeTablePage';

function App() {
  const [selectedDoctor, setSelectedDoctor] = useState(null);

  return (
    <>
      <VStack spacing={4} align="stretch" p={4}>
        {!selectedDoctor ? (
          <DoctorListPage onSelectDoctor={(doctor) => setSelectedDoctor(doctor)} />
        ) : (
          <DoctorTimeTablePage
            doctor={selectedDoctor}
            onBack={() => setSelectedDoctor(null)}
          />
        )}
      </VStack>
    </>
  );
}

export default App;
